import { ChannelCategory } from './channel-category';

export class ChannelGroup {
    id: string;
    vesselId: string;
    displayName: string;
    description?: string;
    categoryId: string;
    rowNum: number;
    excelId: string;
    channelCategory?: ChannelCategory;
}

export function getExistingRowNums(groups: ChannelGroup[]) {
    return groups.map((group: ChannelGroup) => group.rowNum);
}

export const MAX_CHANNEL_GROUPS = 100;
